import React ,{ useState }from "react";

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import Drawer from '@material-ui/core/Drawer';

import {getSalesInsight, getMyAccounts,getMaster,getAccounts ,getDpExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import Checkbox from '@material-ui/core/Checkbox';
//import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';

import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
//import setDisplay from "../../partials/content/CodeExample";
import EditOrderReqStatus from './EditOrderReqStatus'
import FormGroup from '@material-ui/core/FormGroup';



 
import Autocomplete from '@material-ui/lab/Autocomplete';
//import { ThreeDRotationSharp, TrendingUpOutlined } from "@material-ui/icons";
 import BootstrapTable from 'react-bootstrap-table-next';
 import filterFactory, { textFilter,numberFilter } from 'react-bootstrap-table2-filter';
 import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
 import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
 import paginationFactory from 'react-bootstrap-table2-paginator'

 import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

 import Alert from '@material-ui/lab/Alert'
 
 
 import CircularProgress from '@material-ui/core/CircularProgress';
import { Portlet, PortletBody, PortletHeader } from "../../partials/content/Portlet";







//import Moment from 'moment';
 

export default class SalesReport extends React.Component {

	defaultSorted = [{
		dataField: 'month',
		order: 'desc'
	  }];
	
	  columns = [
	 	{
		  dataField: 'month',
		  text: 'Month',
		  width: 150,
		  sort: false,
		  
		},
		{
		  dataField: 'total',
		  text: 'Sales',
		  sort:false,
		  formatter:this.priceFormatter,
		  headerStyle: {
    		width: '100px'
  			}
		 
		}	
	  ];

priceFormatter(cell, row) {
  if (row.total) {
    return (
      <span>
        <strong style={ { color: 'green' } }>$ { cell.toFixed(2) }</strong>
      </span>
    );
  }

  return (
    <span>$ { cell.toFixed(2) }</span>
  );
}
 
  handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };

  state = {
    schedules:[],
    pRights:[],
    hasMoreItems:false,
    page:1,
        isReset:false,

    isLoading:false,
        filterFields :{},
    fields:[],
    filter:false,
    selectedDate:null,
    open:false,
    notes:[],
    notesId:'',
    statusSettings:
        "JOBS00003"
    ,
    postObj:{},
	statusFilter:null,
	selectedDrawerItem:null,
	invoiceDrawerOpen:false,
	invoiceViewDrawerOpen:false,
	jobServiceTypes:[],
	permission:[],
	columns :this.columns,
    defaultSorted: this.defaultSorted,
	tableData:[],
	entity:[],
    accounts:[],
    businessEntity:'',
    selaccount:null,
	lookUp: {product:'productKey',account:'accountKey'},
	groupBy: [],
	reportBy:[],
	dateCreatedTo:null,
	dateCreatedFrom:null,

  }

 constructor(props)
{
	super(props);


}




resetFilter()
{
	let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:false});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;

 
  			})
}

	reserFilterText()
	{
		this.setState({filter:true})
	}

   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:true});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;
			if(field.dataType==='autocomplete')
			{
				this.setState({[field.fieldName]:[],[`Filter_${field.fieldName}`]:''});
				
			}
 
  			})

  			this.setState({activePage:1})
			  
  }

  
 async componentDidMount()
  {
 
  
	this.setState({isLoading:true});

	 await getMaster('entity')
								.then((response)=>
									{
										//console.log('Master :',fieldMap.fieldName);
										//alert(fieldMap.fieldName);
										this.setState({entity:response.data});
								
	
	
									})
	
					await getMyAccounts().then((response)=>{
					  this.setState({accounts:response.data});
					})

   

  	this.setState({hasMoreItems:false,isLoading:true});
  	

    let postObj={};
			
  	

   getSalesInsight("month",'',postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false});
      this.setState({ tableData: response.data});
     
     })


  }
 


handleChangeEntity=(event)=>
 {
   

    this.setState({businessEntity:event.target.value});
  }

  handleChangeAccount=(event)=>
  {
    console.log(event);
    this.setState({selaccount:event.target.value});
	
    
  }
 

    handleFilter(event)
	{
   
	   this.setState({isLoading:true})
	   let params = {};
	   if(this.state.selaccount!==null && this.state.selaccount!=="")
	   {
			console.log(this.state.selaccount);
			params.accountKey = this.state.selaccount;
		 
	   }
	   if(this.state.dateCreatedFrom!==null && this.state.dateCreatedFrom!=="")
	   {
			console.log(this.state.dateCreatedFrom);
			let formattedDate=format(this.state.dateCreatedFrom, 'yyyy-MM-dd');
			params.datefromcreatedOn = formattedDate;
	   }

	   if(this.state.dateCreatedTo!==null && this.state.dateCreatedTo!=="")
	   {
			console.log(this.state.dateCreatedTo);
			let formattedDate=format(this.state.dateCreatedTo, 'yyyy-MM-dd');
			params.datetocreatedOn = formattedDate;
	   }
	   let group = this.state.groupBy.toString();
			if(this.state.groupBy.toString()==="") group="month"; 

		  getSalesInsight(group,this.state.reportBy.toString(),params)//.then(response => response.data)
    	  .then((response) => {
      	 		this.setState({isLoading:false})
      	  		this.setState({ tableData: response.data,columns:this.state.columns,postObj:params})
     
     		})
		
	   
   
	 }

	autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
		if(event!==null && newValue!==null)
		{
		  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
		  this.setState({[fieldName]:newValue[lookupKey]});
		}
		
	  }
	
 handleGroupByChange = (event) => {
	let groupFields = this.state.groupBy;
	let index = groupFields.findIndex((x)=> x===event.target.value);
	console.log("inde::::",index);
	if(index<0)
		groupFields.push(event.target.value)
	else
		groupFields.splice(index,1)

	console.log(groupFields);

    this.setState({isLoading:true,groupBy: groupFields});

    let tableColumns = [];
	groupFields.map((f)=>{
		tableColumns.push({
		 dataField: f,
		  text: String(f).charAt(0).toUpperCase() + String(f).slice(1),
		  width: 150,
		  sort: false,
	});
	})
	this.state.reportBy.map((f)=>{
		tableColumns.push({
			dataField: this.state.lookUp[f],
			text: String(f).charAt(0).toUpperCase() + String(f).slice(1),
			width: 150,
			sort: false,
		});
	})
	
	tableColumns.push({
		dataField: 'total',
		  text: 'Sales',
		  sort:false,
		  formatter:this.priceFormatter,
		   headerStyle: {
    		width: '100px'
  			}
		 
	});
	 
	 getSalesInsight(groupFields.toString(),this.state.reportBy.toString(),this.state.postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ tableData: response.data,columns:tableColumns})
     
     })
  };


   handleReportByChange = (event) => {
	
	let reportFields = this.state.reportBy;
	let index = reportFields.findIndex((x)=> x===event.target.value);
	console.log("inde::::",index);
	if(index<0)
		reportFields.push(event.target.value)
	else
		reportFields.splice(index,1)

	console.log(reportFields);

    this.setState({isLoading:true,reportBy: reportFields});
	let tableColumns = [];
	this.state.groupBy.map((f)=>{
		tableColumns.push({
		 dataField: f,
		  text: String(f).charAt(0).toUpperCase() + String(f).slice(1),
		  width: 150,
		  sort: false,
	});
	})
	reportFields.map((f)=>{
		tableColumns.push({
			dataField: this.state.lookUp[f],
			text: String(f).charAt(0).toUpperCase() + String(f).slice(1),
			width: 150,
			sort: false,
		});
	})		
	
	tableColumns.push({
		dataField: 'total',
		  text: 'Sales',
		  sort:false,
		  formatter:this.priceFormatter,
		   headerStyle: {
    		width: '100px'
  			}
		 
	});
	 
	 getSalesInsight(this.state.groupBy.toString(),reportFields.toString(),this.state.postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ tableData: response.data,columns:tableColumns})
     
     })
  };
	  

	 exportClick(event)
	{
	  	let postObj={};
	
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
						 postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
					   else if(field.dataType==="dropdown")
						{	  				 	
							postObj['cdnbool'+field.fieldName]=this.state[`Filter_${field.fieldName}`].toString();
						}
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			}) 
	  		   
	  		    getDpExport(postObj)
					    .then((response) => {
					      if(response.data!=""){
					    	var win = window.open(response.data, '_blank');
  							win.focus();}
  							else
  								alert('Error exporting records')
					    })
	}

  render() {
  	//console.log("schedule::::",this.state.schedule);
    return (
      <>

        <div className="row">
			<div className= "col-md-12">
				<Portlet>
					<PortletHeader title="Sales Insight Report"></PortletHeader>
				</Portlet>
			</div>
		</div>

      	<div className="row">

          	<div className="col-md-12">
            <CodeExample jsCode="true" beforeCodeTitle="Filter">
						   <div className="kt-section" >
							 <Grid container spacing={3}>
							 
							   <Grid item xs={12} sm={6}>
								 <TextField  style={{'width':'100%'}} name="businessEntity" 
									 id="businessEntity"  label="Account Type"
									 onChange={this.handleChangeEntity}
									 value={this.state.businessEntity}
									   select>
										 
									 <MenuItem value="">Select</MenuItem>
									 { 
									 this.state.entity.length>0 && this.state.entity.map((ent) => (
									   
									   <MenuItem key={ent.businessEntity} value={ent.businessEntity}>{ent.businessEntity}</MenuItem>
										 
									 ))
									 }
									
								 </TextField>
		   
							   </Grid>
							   <Grid item xs={12} sm={6}>
								 <TextField  style={{'width':'100%'}} name="accountKey" 
									 id="accountKey"  label="Account"
									 onChange={this.handleChangeAccount}
									   select>
									
									 { 
									 this.state.accounts.length>0 && this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).length>0 && this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).map((acc) => (
									   
									   <MenuItem key={acc.accountId} value={acc.accountId}>{acc.accountName}</MenuItem>
										 
									 ))
									 }
									 {
									   this.state.accounts.filter(x=>x.businessEntity===this.state.businessEntity).length===0 &&
										 <MenuItem value="">None</MenuItem>
									 }
								 </TextField>
		   
							   </Grid>
							   <Grid item xs={12} sm={6}>
								 <MuiPickersUtilsProvider  utils={DateFnsUtils}>
										  
									<KeyboardDatePicker
										fullWidth
										id="date"
										label={'Date Created From'}
									    name = {'dateCreatedFrom'}
										format="MM/dd/yyyy"
										value={this.state.dateCreatedFrom}
										onChange={date =>this.setState({dateCreatedFrom:date})}
										KeyboardButtonProps={{
											'aria-label': 'change date',
										}}
									/>
																		  
								</MuiPickersUtilsProvider>
							 </Grid>
							 <Grid item xs={12} sm={6}>
								 <MuiPickersUtilsProvider  utils={DateFnsUtils}>
										  
									<KeyboardDatePicker
										fullWidth
										id="date"
										label={'Date Created To'}
									    name = {'dateCreatedTo'}
										format="MM/dd/yyyy"
										value={this.state.dateCreatedTo}
										onChange={date =>this.setState({dateCreatedTo:date})}
										KeyboardButtonProps={{
											'aria-label': 'change date',
										}}
									/>
																		  
								</MuiPickersUtilsProvider>
							 </Grid>
							 </Grid>
						   </div>
					   
					   <div>
					   <Button
					 variant="outlined"
					 color="primary"
					 onClick={this.handleFilter.bind(this)}
					 endIcon={<Icon>search</Icon>}
					 style={{'padding':'10px','margin':'10px'}}
					 >
					 {
					   this.state.isLoading==true&&<><Bounce /></>
					 }
					 {
					   this.state.isLoading==false&&<>Apply Filter</>
					 }
					 </Button>
					 
					 <Button
					 variant="outlined"
					 color="primary"
					 onClick={this.handleReset.bind(this)}
					 endIcon={<Icon>backspace</Icon>}
					 style={{'padding':'10px','margin':'10px'}}
					 >
					 {
					   this.state.isReset==true&&<><Bounce /></>
					 }
					 {
					   this.state.isReset==false&&<>Reset Filter</>
					 }
					 </Button>
					 </div>
		   
						 </CodeExample>
          	</div>
        </div>
		    
		<div className="row">

          	<div className="col-md-12">
				<Portlet>
					<PortletHeader title="Group By"></PortletHeader>
					<PortletBody>
					
						<Grid container spacing={3}>
							<Grid item xs={12} sm={6}>
								{/*<RadioGroup row aria-label="groupBy" name="groupBy" value={this.state.groupBy} onChange={this.handleGroupByChange}>
									<FormControlLabel value="day" control={<Radio />} label="Day" />
									<FormControlLabel value="month" control={<Radio />} label="Month" />
									<FormControlLabel value="year" control={<Radio />} label="Year" />
									
								</RadioGroup>*/}
								
									<FormGroup row={true}>
										<FormControlLabel
											control={<Checkbox  onChange={this.handleGroupByChange} value={'day'} name={'groupBy'} />}
											label={'Day'}
										/>
										<FormControlLabel
											control={<Checkbox  onChange={this.handleGroupByChange} value={'month'} name={'groupBy'} />}
											label={'Month'}
										/>
										<FormControlLabel
											control={<Checkbox  onChange={this.handleGroupByChange} value={'year'} name={'groupBy'} />}
											label={'Year'}
										/>
									
										<FormControlLabel
											control={<Checkbox  onChange={this.handleReportByChange} value={'account'} name={'reportBy'} />}
											label={'Practice'}
										/>
										<FormControlLabel
											control={<Checkbox  onChange={this.handleReportByChange} value={'product'} name={'reportBy'} />}
											label={'Product'}
										/>
								</FormGroup>
																								
																						 
			
							</Grid>
							<Grid item xs={12} sm={6}>
								{/*<RadioGroup row aria-label="reportBy" name="reportBy" value={this.state.reportBy} onChange={this.handleReportByChange}>
									<FormControlLabel value="account" control={<Radio />} label="Practice" />
									<FormControlLabel value="product" control={<Radio />} label="Product" />
									<FormControlLabel value="default" control={<Radio />} label="Default" />
									
								</RadioGroup>*/}

								
											
							</Grid>
						</Grid>
					</PortletBody>
				</Portlet>
          	</div>
        </div>
		
			<div className="kt-portlet">
				<div className="kt-portlet__body">
					<div className="row">
						<div className="col-md-12">
							<Grid beforeCodeTitle="Accounts" jsCode="true">
								<div className="kt-section">
									{this.state.isLoading===false &&
									<BootstrapTable
										bootstrap4
										keyField="orderKey"
										data={ this.state.tableData }
										columns={ this.state.columns }
										defaultSorted={ this.state.defaultSorted } 
										filter={ filterFactory() }
										pagination={ paginationFactory()}
										paginationSize={100}
										/>
									}
									 {this.state.isLoading && (
															<div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
															  <Alert severity={'info'} icon={this.state.isLoading && <CircularProgress size={15} />}>&nbsp;&nbsp;{'Loading please wait...'}</Alert>      
															</div>
															  )}
								</div>
							</Grid>
						</div>
					</div>
				</div>
			</div>
		
      	
	
		
					
       
		
	
    
      </>
    );
  }
}
